<template>
  <el-popover
      placement="right"
      width="320"
      :trigger="trigger">
    <div
        class="summary-report-popover">
      <h3>{{ title }}</h3>
      <div>
        <div
            v-for="field in summaryFields"
            :key="field.path"
            class="summary-lines"
            style="font-size: smaller">
          <div
              class="grid"
              style="padding: 7px 0px;">
            <div class="span-6">
              <span style="display: inline-block;  float: left"> {{ field.label }}</span>
            </div>
            <div class="span-6">
              <el-tag
                  style="display: inline-block;  float:right"
                  size="small"
                  type="info">
                {{ reportProxy(field.path) }}
              </el-tag>
            </div>
          </div>
        </div>
      </div>
      <div
          v-if="dataFound"
          class="flex justify-center iperf-timestamp">
        <span>{{ timestamp }}</span>
      </div>
      <div v-if="!dataFound">
        <el-table
            :data="[]"
            style="width: 100%" />
      </div>
    </div>

    <section
        slot="reference"
        style="display: inline-block">
      <slot>
        <i class="el-icon-info sr_summary-icon"></i>
      </slot>
    </section>
  </el-popover>
</template>

<script>
import { cloneDeep, get, keys, intersection, isEmpty } from "lodash";

let NULL_REPORT = () => cloneDeep({ data: {}, admin_panel: {} });
const IPERF_CONTEXTS = [4, 13];
export default {
  name: "SummaryReportPopover",
  props: {
    iperfOnly: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Report Summary",
    },
    trigger: {
      type: String,
      default: "hover",
    },
    report: {
      type: Object,
      default() {
        return NULL_REPORT();
      },
    },
  },
  data() {
    return {
      summary: {
        fields: [
          {
            path: "data.status.rssi",
            label: "RSSI",
            filter: "number",
          },
          {
            path: "admin_panel.iperf_test_results.iperf_tcp_throughput",
            label: "TCP Throughput",
            iperf: true,
          },
          {
            path: "admin_panel.iperf_test_results.iperf_udp4_bandwidth",
            label: "UDP 4Mbit Bandwidth",
            iperf: true,
          },
          {
            path: "admin_panel.iperf_test_results.iperf_udp4_jitter",
            label: "UDP 4Mbit Jitter",
            iperf: true,
          },
          {
            path: "admin_panel.iperf_test_results.iperf_udp1_pkts_sent",
            label: "UDP 1Mbit Sent",
            iperf: true,
          },
          {
            path: "admin_panel.iperf_test_results.iperf_udp1_pkts_rcvd",
            label: "UDP 1Mbit Rcvd",
            iperf: true,
          },
          {
            path: "admin_panel.iperf_test_results.iperf_udp2_pkts_sent",
            label: "UDP 2Mbit Sent",
            iperf: true,
          },
          {
            path: "admin_panel.iperf_test_results.iperf_udp2_pkts_rcvd",
            label: "UDP 2Mbit Rcvd",
            iperf: true,
          },
          {
            path: "admin_panel.iperf_test_results.iperf_udp4_pkts_sent",
            label: "UDP 4Mbit Sent",
            iperf: true,
          },
          {
            path: "admin_panel.iperf_test_results.iperf_udp4_pkts_rcvd",
            label: "UDP 4Mbit Rcvd",
            iperf: true,
          },
        ],
      },
    };
  },
  computed: {
    summaryFields() {
      // show fields only if the property exist
      let fieldList = this.summary.fields.filter((field) => {
        let path = field.path.split(".");
        let prop = path.pop();
        path = path.join(".");
        return get(this.report, path, {}).hasOwnProperty(prop);
      });
      return this.iperfOnly
        ? fieldList.filter((field) => Boolean(field.iperf))
        : fieldList;
    },
    dataFound() {
      return this.summaryFields.length && this.reportGiven;
    },
    reportGiven() {
      let report = get(this, "report", {});
      return this.report !== null && keys(report).length > 1;
    },
    timestamp() {
      let tm = get(this.report, "timestamp", null);
      if (!tm) return;
      let tz = this.$store.getters["ui/currentTimezone"];
      return this.$moment.tz(tm, tz).format("MM/DD/YYYY - hh:mm A Z (z)");
    },
  },
  created() {
    this.addBatteryInfo(this.summary.fields);
  },
  methods: {
    reportProxy(path) {
      return get(this.report, path, null);
    },
    get,
    addBatteryInfo(fields) {
      let battery = get(this.report, "admin_panel.battery", {});
      if (battery.hasOwnProperty("null?") && battery["null?"] !== true) {
        fields.push({
          path: "admin_panel.battery.temperature",
          label: "Temperature",
        });
        fields.push({
          path: "admin_panel.battery.fg_soc",
          label: "FG Soc",
        });
        fields.push({
          path: "admin_panel.battery.human_readable",
          label: battery.desc,
        });
        fields.push({
          path: "admin_panel.battery.power_source",
          label: "Power Source",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.sr_summary-icon {
  color: $--color-curious-blue;
}
.summary-report-popover {
  .summary-lines:nth-child(even) {
    background-color: $--color-athens-gray;
  }
}
.iperf-timestamp {
  font-size: 14px;
  margin: 10px;
  color: #909399;
}
</style>
